module.exports = __webpack_public_path__ + "img/img-up-btn.ac782c00.svg";